import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	PrimaryGeneratedColumn,
} from 'typeorm';
import { EmailFolderEntity } from './email-folder.entity';
import { EmailRecordEntity } from './email-record.entity';

// Junction between email_record and email_folder. A record can live in many
// folders (e.g. categorized mail, Sent + Inbox conversation pairs) and a
// folder holds many records. Deliberately does NOT extend BaseEntity — this
// table is system-managed by the email sync pipeline; audit context lives
// in the email service's logs, not on the row.
@Entity('email_record_folder')
@Index('UQ_email_record_folder_pair', ['fkEmailRecordId', 'fkEmailFolderId'], {
	unique: true,
})
export class EmailRecordFolderEntity {
	@PrimaryGeneratedColumn({ name: '_id', type: 'bigint', unsigned: true })
	public id!: string;

	@Column({ name: 'fk_email_record__id', type: 'bigint', unsigned: true })
	public fkEmailRecordId!: string;

	@ManyToOne(() => EmailRecordEntity, (record) => record.folderLinks, {
		onDelete: 'CASCADE',
	})
	@JoinColumn({ name: 'fk_email_record__id' })
	public emailRecord!: EmailRecordEntity;

	@Column({ name: 'fk_email_folder__id', type: 'bigint', unsigned: true })
	public fkEmailFolderId!: string;

	@ManyToOne(() => EmailFolderEntity, (folder) => folder.recordLinks)
	@JoinColumn({ name: 'fk_email_folder__id' })
	public emailFolder!: EmailFolderEntity;
}
